import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { List, ListItemButton, ListItemIcon, ListItemText, Typography, Divider, Box } from "@mui/material";
import useAuth from "../../providers/authProvider";
import DashboardIcon from '@mui/icons-material/Dashboard';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PaymentsIcon from '@mui/icons-material/Payments';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import EuroIcon from '@mui/icons-material/Euro';
import PeopleIcon from '@mui/icons-material/People';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';


export function Menu() {
  const { role } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const sections = [
    {
      title: "Dashboards",
      items: [
        { path: '/producer-dashboard', label: 'Producer DB', icon: <DashboardIcon />, roles: ['READER', 'ADMIN'] },
        { path: '/operator-dashboard', label: 'Operator DB', icon: <DashboardIcon />, roles: ['READER', 'ADMIN'] },
        { path: '/operators-balance-dashboard', label: 'Operators Balance DB', icon: <AccountBalanceIcon />, roles: ['READER', 'ADMIN'] },
        { path: '/payout-dashboard', label: 'Payout', icon: <PaymentsIcon />, roles: ['READER', 'FINANCE', 'ADMIN'] },
      ]
    },
    {
      title: "Data",
      items: [
        { path: '/invoice', label: 'Invoices', icon: <ReceiptLongIcon />, roles: ['READER', 'ADMIN'] },
        { path: '/commission', label: 'Commissions', icon: <EuroIcon />, roles: ['READER', 'ADMIN'] },
        { path: '/producer', label: 'Producers', icon: <PeopleIcon />, roles: ['READER', 'ADMIN'] },
        { path: '/user', label: 'Users', icon: <AdminPanelSettingsIcon />, roles: ['ADMIN'] },
      ]
    }
  ];
  
return (
    <Box sx={{ 
      width: 200, 
      minWidth: 200, 
      maxWidth: 200, 
      height: '100%', 
      bgcolor: '#fcfcfc',
      flexShrink: 0,
      borderRight: '1px solid #e0e0e0',
      overflowX: 'hidden' 
    }}>
      {sections.map((section, idx) => (
        <React.Fragment key={section.title}>
          {idx !== 0 && <Divider sx={{ my: 1, mx: 2 }} />}
          <List sx={{ px: 1, pt: 1 }}>
            <Typography variant="caption" sx={{ 
              px: 2, pb: 0.5, display: 'block', fontWeight: 700, 
              color: 'text.disabled', textTransform: 'uppercase', fontSize: '0.6rem',
              whiteSpace: 'nowrap' 
            }}>
              {section.title}
            </Typography>

            {section.items.filter(i => i.roles.includes(role)).map((item) => {
              const isSelected = pathname === item.path;
              return (
                <ListItemButton
                  key={item.path}
                  onClick={() => navigate(item.path)}
                  selected={isSelected}
                  disableRipple
                  sx={{
                    py: 0.5,
                    px: 1,
                    borderRadius: 1.5,
                    mb: 0.3,
                    display: 'flex', 
                    flexDirection: 'row', 
                    flexWrap: 'nowrap',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    width: '100%',
                    '&.Mui-selected': {
                      bgcolor: 'primary.main',
                      color: 'white',
                      '& .MuiListItemIcon-root': { color: 'white' }
                    }
                  }}
                >
                  <ListItemIcon sx={{ 
                    minWidth: 32, 
                    flexShrink: 0, 
                    color: isSelected ? 'white' : 'text.secondary' 
                  }}>
                    {React.cloneElement(item.icon as React.ReactElement, { sx: { fontSize: 19 } })}
                  </ListItemIcon>
                  
                  <ListItemText
                    primary={item.label}
                    primaryTypographyProps={{
                      fontSize: '0.75rem',
                      fontWeight: isSelected ? 700 : 500,
                      sx: { 
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: 'block'
                      }
                    }}
                  />
                </ListItemButton>
              );
            })}
          </List>
        </React.Fragment>
      ))}
    </Box>
  );
}